import { gql } from '@apollo/client';

export const regenQRGql = gql`
  mutation regenQR($contractId: String!) {
    regenerateQrcode(contractId: $contractId) {
      contract {
        _id
        credentials {
          type
          provider
          value
          _id
          description
        }
      }
    }
  }
`;
